import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import Popover from '@material-ui/core/Popover'
import List from '@material-ui/core/List'
import ListSubheader from '@material-ui/core/ListSubheader'
import { localized, withDialogs } from 'decorators'
import { LoadingIndicator } from 'components/loading'
import { downloadFile } from 'utils/downloader'
import { Button } from 'components/buttons'
import { actionCreators } from 'store/modules/fileAttachments'

import { FileAttachmentItem } from './item'
import { useStyles } from './index.css'

const process = (items) => {
  let lastLawId = -1
  return items.map(x => {
    const item = {...x, showLaw: x.lawId !== lastLawId}
    lastLawId = x.lawId
    return item
  })
}

const RefreshArea = ({ classes, localize, fetching, onRefresh }) => {
  return (
    <div className={classes.refresh}>
      {fetching && <div className={classes.loading}><LoadingIndicator size={20} /></div>}
      <Button width={25} disabled={fetching} color='primary' icon='refresh' title={localize('common.refresh')} onClick={onRefresh} />
    </div>
  )
}
export const FileAttachmentsButton = connect(
  ({ fileAttachments }) => ({ fileAttachments }),
  { get: actionCreators.get, delete: actionCreators.delete, refresh: actionCreators.refresh }
)(withDialogs(localized((props) => {
  const { get, localize, showAlert } = props
  useEffect(() => { get() }, [get, props.fileAttachments.gridKey])
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = React.useCallback((e) => {
    setAnchorEl(e.currentTarget)
  }, [setAnchorEl])
  const handleClose = React.useCallback(() => {
    setAnchorEl(null)
  }, [setAnchorEl])

  const handleError = React.useCallback((err) => {
    showAlert({ message: (err || {}).message || localize('common.errorOccurred') })
  }, [localize, showAlert])

  const { fileAttachments, refresh } = props
  const { entity, fetching } = fileAttachments
  const items = (Array.isArray(entity) ? entity : [])
  const hasFiles = items.length > 0
  const newItemsCount = items.filter(x => x.isNew).length
  const processedItems = process(items)
  return (
    <div className={classes.root}>
      <IconButton color='inherit' onClick={handleClick}>
        <Badge badgeContent={newItemsCount} color='secondary'>
          <CloudDownloadIcon />
        </Badge>
      </IconButton>
      <Popover
        id='file-attachments-popover'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <List className={classes.listRoot} subheader={<ListSubheader className={classes.header} color='primary' component='div'>{localize('fileAttachments.title')} <RefreshArea fetching={fetching} localize={localize} classes={classes} onRefresh={refresh} /></ListSubheader>}>
          {hasFiles && processedItems.map((item, index) => <FileAttachmentItem onDelete={props.delete} onDownload={downloadFile} onError={handleError} className={classes.item} key={index} fileAttachment={item} />)}
          {!hasFiles && <FileAttachmentItem />}
        </List>
      </Popover>
    </div>
  )
})))
